module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="search_icon"></div>\n<input id="search_box" type="text" placeholder="Search @username, #hashtag, or caption" data-attr="caption">\n<div id="clear_search"></div>';

}
return __p
}